import React, { Component } from "react";
import {
  withStyles,
  Card,
  CardHeader,
  Avatar,
  Typography,
  CardContent,
  Grid,
  TextField,
  CardActions,
  Button,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import Add from "@material-ui/icons/Add";
import { PutData, DeleteData } from "../../api/service";
import Snack from "../Snackbar/Snack";
import Rich from "../AddNew/Rich";
import FileUpload from "../AddNew/FileUpload";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const styles = (theme) => ({
  textField: {
    width: "100%",
  },
  formControl: {
    width: "100%",
    marginTop: theme.spacing.unit * 2,
  },
});

class EditFeaturedNotification extends Component {
  state = {
    id: "",
    date: "",
    title: "",
    description: "",
    desc: "",
    uploadInfo: [],
    is_active: 0,
    edit: false,
    open: false,
    message: "",
  };

  __loadData() {
    let data = this.props.history.location.state;
    if (!data) return;

    let upload = [];
    try {
      upload =
        typeof data.upload_info === "string"
          ? JSON.parse(data.upload_info)
          : data.upload_info || [];
    } catch (e) {
      upload = [];
    }

    this.setState({
      id: data.id,
      date: data.date || "",
      title: data.title || "",
      description: data.description || "",
      desc: data.description || "",
      uploadInfo: upload || [],
      is_active: parseInt(data.is_active) === 1 ? 1 : 0,
      edit: true,
    });
  }

  componentDidMount() {
    this.__loadData();
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.__loadData();
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleCheckboxChange = (e) => {
    this.setState({
      [e.target.name]: e.target.checked ? 1 : 0,
    });
  };

  handleRichChange = (data) => {
    this.setState({
      description: data,
    });
  };

  onSetFile = (data) => {
    this.setState({
      uploadInfo: data,
    });
  };

  onSubmit = (e) => {
    e.preventDefault();

    let data = {
      ...this.state,
    };

    PutData(
      `/${this.props.apikey}/${this.state.id}/edit-featured-notification`,
      data
    ).then((resp) => {
      this.setState({
        open: true,
        message: resp,
      });
    });
  };

  delete = () => {
    let id = this.state.id;
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.confirmDelete(id),
        },
        {
          label: "No",
        },
      ],
    });
  };

  confirmDelete = (id) => {
    DeleteData(`/${this.props.apikey}/${id}/delete-featured-notification`)
      .then((resp) => {
        this.setState({
          open: true,
          message: resp,
        });
      })
      .then(() => {
        this.props.history.replace("/featured-notification");
      });
  };

  render() {
    let { classes } = this.props;

    return (
      <div>
        {this.state.open ? (
          <Snack
            open={this.state.open}
            handleClose={() => {
              this.setState({
                open: false,
                message: "",
              });
            }}
            message={this.state.message}
          />
        ) : null}
        <form onSubmit={this.onSubmit}>
          <Card>
            <CardHeader
              avatar={
                <Avatar>
                  <Add />
                </Avatar>
              }
              title={
                <Typography variant="h6">
                  Edit Featured Notification
                </Typography>
              }
            />
            <CardContent>
              <Grid container spacing={24}>
                <Grid item lg={4} sm={12}>
                  <TextField
                    label="Date"
                    className={classes.textField}
                    type="date"
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required={true}
                    name="date"
                    value={this.state.date}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item lg={8} sm={12}>
                  <FormControlLabel
                    style={{ marginTop: "20px" }}
                    control={
                      <Checkbox
                        checked={this.state.is_active === 1}
                        onChange={this.handleCheckboxChange}
                        name="is_active"
                        color="primary"
                      />
                    }
                    label="Mark as Active (will deactivate all others)"
                  />
                </Grid>

                <Grid item lg={12} sm={12}>
                  <TextField
                    label="Title"
                    className={classes.textField}
                    type="text"
                    margin="normal"
                    variant="outlined"
                    required={true}
                    name="title"
                    value={this.state.title}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item lg={12} sm={12}>
                  {this.state.edit ? (
                    <Rich
                      placeholder="Description....."
                      onChange={this.handleRichChange}
                      edit={this.state.desc}
                    />
                  ) : null}
                </Grid>

                <Grid item lg={12} sm={12}>
                  {this.state.edit ? (
                    <FileUpload
                      dp={this.state.uploadInfo}
                      apikey={this.props.apikey}
                      type="featured_notification"
                      setDp={this.onSetFile.bind(this)}
                    />
                  ) : null}
                </Grid>
              </Grid>
            </CardContent>

            <CardActions>
              <Button variant="outlined" color="primary" type="submit">
                Update
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                type="button"
                onClick={this.delete}
              >
                Delete
              </Button>
            </CardActions>
          </Card>
        </form>
      </div>
    );
  }
}

export default withStyles(styles)(EditFeaturedNotification);



// WEBPACK FOOTER //
// ./src/Components/FeaturedNotification/EditFeaturedNotification.js